// Renders editable heading text. Wrap words in ~tildes~ in the admin to highlight
// them in the section's accent colour; newlines become line breaks.
export function accentText(text, cls = "text-pink") {
  return String(text ?? "").split("\n").map((line, li, arr) => (
    <span key={li}>
      {line.split("~").map((part, i) =>
        i % 2 === 1 ? <span key={i} className={cls}>{part}</span> : part
      )}
      {li < arr.length - 1 && <br />}
    </span>
  ));
}
